<ag-memo-list
  [service]="studentApiService"
  [referenceId]="studentId"
  newText="新規作成"
  title="状況メモ"
  (errorGetMemos)="errorGetMemosCallback($event)"
></ag-memo-list>
